import { useState, useEffect } from 'react';
import UseArea from './UseArea';
import styled from 'styled-components';
import {
  ModalInner,
  ModalTitle,
  Section,
  SectionBox,
  ResetBtn,
  ResetBtnText,
  ApplyBtn,
} from './SelectModal.styles';
interface Props {
  selected: string[];
  onApply: (v: string[]) => void;
  onClose: () => void;
}

const UseAreaModal = ({ selected, onApply, onClose }: Props) => {
  const [localUseArea, setLocalUseArea] = useState<string[]>(selected ?? []);

  const handleReset = () => {
    setLocalUseArea([]);
  };

  const handleApply = () => {
    onApply(localUseArea);
    onClose();
  };
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <Overlay>
      <ModalContainer>
        <Header>
          <span>
            <ImgBox>
              <img
                src="/assets/images/arrow/arrow-left-black.svg"
                alt="back"
                onClick={onClose}
              />
            </ImgBox>
            용도지역
          </span>
          <ImgBox>
            <img
              src="/assets/images/close/close-dark-gray.svg"
              alt="close"
              onClick={onClose}
              style={{ cursor: 'pointer', width: 24 }}
            />
          </ImgBox>
        </Header>

        <Body>
          <UseArea
            filters={{ useArea: localUseArea }}
            setFilters={(updated) => setLocalUseArea(updated.useArea)}
          />
        </Body>
        <Footer>
          {localUseArea.length > 0 && (
            <SelectedTags>
              {localUseArea.slice(0, 2).map((tag: string, index: number) => (
                <Tag key={index}>
                  {tag}
                  <RemoveButton
                    onClick={() =>
                      setLocalUseArea(localUseArea.filter((t) => t !== tag))
                    }
                  >
                    ×
                  </RemoveButton>
                </Tag>
              ))}
              {localUseArea.length > 2 && <Tag>+{localUseArea.length - 2}</Tag>}
            </SelectedTags>
          )}

          <div>
            <ResetButton onClick={handleReset}>
              <img src="/assets/images/icon/reload-gray.svg" alt="" />
              <span>초기화</span>
            </ResetButton>
            <ApplyBtn onClick={handleApply} active={localUseArea.length > 0}>
              {localUseArea.length > 0
                ? `${localUseArea.length}개 적용`
                : '적용'}
            </ApplyBtn>
          </div>
        </Footer>
      </ModalContainer>
    </Overlay>
  );
};

export default UseAreaModal;
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999;
`;

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  font-weight: bold;
  font-size: 16px;
  span {
    display: flex;
    align-items: center;
  }
`;
const ImgBox = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
`;
const Body = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`;

const Footer = styled.div`
  border-top: 1px solid rgba(112, 115, 124, 0.22);
  padding: 16px;
  > div:last-child {
    display: flex;
    gap: 12px;
  }
`;
const ResetButton = styled.button`
  padding: 7px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  color: #616161;
  background-color: #fff;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  text-wrap: nowrap;
  img {
    width: 24px;
    height: 24px;
  }
`;

const SelectedTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 16px;
`;

const Tag = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 2px;
  border-radius: 9999px;
  border: 1px solid #e1e2e4;
  background: rgba(112, 115, 124, 0.05);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: #222;
`;

const RemoveButton = styled.div`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
`;
